import styled from 'styled-components'

export const Container = styled.div`
    margin: 0 0.5rem 0.5rem 0.5rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;

    @media (max-width: 800px){
        grid-template-rows: repeat(2, 1fr);
        grid-template-columns: 1fr;
    }
`

export const Card = styled.div`
    padding: 1rem 0;
    background: var(--colorBackgroundCardsDashboard);
    border-radius: 0.25rem;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;

    min-height: 17rem;
`

export const Title = styled.p`
    font-size: 1.2rem;
    color: var(--colorFontsCardsDashboard);
    font-weight: 700;
    position: absolute;
    top: 10px;
    bottom: 0;
`

export const ContainerCardsSalesChannels = styled.div`
    width: 100%;
    height: 100%;
    margin-top: 20px;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

`